import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.season.form.dropdown');
import { OnInit } from '@angular/core';
import { Input } from '@angular/core';
import { ContentChild, TemplateRef } from '@angular/core';
import { ElementRef } from '@angular/core';
import { HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-season-form-dropdown',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.season.form.dropdown/view.scss */
.tw-dropdown {
  max-width: 100%;
}

.tw-dropdown-menu {
  display: none;
  max-height: min(24rem, 100vh - 6rem);
  max-width: min(20rem, 100vw - 2rem);
  overflow-y: auto;
  overscroll-behavior: contain;
}
.tw-dropdown-menu.show {
  display: block;
}`],
})
export class PortalSeasonFormDropdownComponent implements OnInit {
    @Input() menuStyle: any = {};

    constructor(@Inject( Service) public service: Service,@Inject( ElementRef)  private elementRef: ElementRef) { }

    public isOpen: boolean = false;

    @ContentChild('button') button: TemplateRef<any>;
    @ContentChild('menu') menu: TemplateRef<any>;

    public async ngOnInit() { }

    public async toggle(stat: any = null) {
        if (stat !== null) {
            this.isOpen = stat;
        } else {
            this.isOpen = !this.isOpen;
        }
        await this.service.render();
    }

    public dropdownMenuStyle() {
        const custom = this.styleObject(this.menuStyle);
        if (!this.isOpen) return custom;

        const host = this.elementRef.nativeElement.querySelector('.tw-dropdown') as HTMLElement;
        if (!host) return custom;

        const rect = host.getBoundingClientRect();
        const viewportWidth = window.innerWidth || document.documentElement.clientWidth || rect.width;
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 640;
        const margin = 8;
        const gap = 8;
        const customWidth = this.pixelValue(custom.width);
        const maxAllowedHeight = Math.max(72, viewportHeight - margin * 2);
        const menuWidth = Math.min(Math.max(customWidth || 192, rect.width), Math.max(160, viewportWidth - margin * 2));
        const availableBelow = Math.max(0, viewportHeight - rect.bottom - margin);
        const availableAbove = Math.max(0, rect.top - margin);
        const openUp = availableBelow < 220 && availableAbove > availableBelow;
        const availableHeight = openUp ? availableAbove : availableBelow;
        const menuHeight = Math.min(Math.max(72, availableHeight - gap), 384, maxAllowedHeight);

        let left = rect.right - menuWidth;
        if (left + menuWidth > viewportWidth - margin) left = viewportWidth - margin - menuWidth;
        if (left < margin) left = margin;

        let top = openUp ? rect.top - gap - menuHeight : rect.bottom + gap;
        const maxTop = viewportHeight - margin - menuHeight;
        if (top > maxTop) top = maxTop;
        if (top < margin) top = margin;

        const style = Object.assign({}, custom, {
            left: `${Math.round(left)}px`,
            top: `${Math.round(top)}px`,
            maxHeight: `${Math.round(menuHeight)}px`
        });
        if (!custom.width) style.width = `${Math.round(menuWidth)}px`;
        return style;
    }

    private styleObject(style: any) {
        if (style && typeof style === 'object' && !Array.isArray(style)) return style;
        return {};
    }

    private pixelValue(value: any) {
        if (typeof value === 'number') return value;
        if (typeof value === 'string' && value.endsWith('px')) return Number(value.replace('px', '')) || 0;
        return 0;
    }

    @HostListener('window:resize')
    @HostListener('window:scroll')
    public refreshPosition() {
        if (this.isOpen) this.service.render();
    }

    @HostListener('document:click')
    public clickout() {
        if (this.isOpen)
            this.isOpen = false;
        this.service.render();
    }
}

export default PortalSeasonFormDropdownComponent;